<button type="button" class="btn btn-primary" id="{{modalOpenButtonId}}" [hidden]="true" data-toggle="modal"
  [attr.data-target]="'#' + modalId" data-backdrop="static" data-keyboard="false" data-dismiss="modal">Hidden
  Btn</button>

<div class="modal" id="{{modalId}}" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="{{modalId}}Title">{{modalHeader}}</h5>
        <button type="button" id="{{modalCloseButtonId}}" (click)="onCancel()" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body fix-height-20 d-flex justify-content-center">
        <div *ngIf="content != null" class="align-self-center text-center" style="white-space: pre-line;">{{content}}</div>
      </div>

      <div class="modal-footer">
        <button type="button" [ngClass]="cancelButtonClass" (click)="onCancel()">No</button>
        <button type="button" [ngClass]="submitButtonClass" (click)="onConfirm()">Yes</button>
      </div>
    </div>
  </div>
</div>